import { Component, input, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import {
  BusinessInput,
  Coordinates,
} from 'src/app/shared/models/businessInput.model';
import {
  CustomerAddress,
  CustomerInput,
} from 'src/app/shared/models/customer.model';
import { BusinessService } from 'src/app/shared/services/business.service';
import { CustomerService } from 'src/app/shared/services/customer.service';
import { GooglePlacesService } from 'src/app/shared/services/google-places.service';
import _ from 'lodash-es';
export interface GMapsSuggestionInput {
  destination: string;
  latLong: string;
}

@Component({
  selector: 'simpayx-add-address-profile',
  templateUrl: './add-address-profile.component.html',
  styleUrls: ['./add-address-profile.component.scss'],
})
export class AddAddressProfileComponent implements OnInit {
  @Input() customerDetails: CustomerInput;
  @Input() addresses: CustomerAddress[] = [];
  @Input() addressToEdit: CustomerAddress;
  saveAddress: boolean = true;
  destinationAddress;
  autocompleteResults: any[] = [];
  addressForm: FormGroup;
  selectedTag: string;
  tagSet = new Set<string>();
  businessCoordinates: Coordinates;
  businessSubscription: Subscription;
  business: BusinessInput;
  addressTags = [
    { label: 'Home', value: 'HOME' },
    { label: 'Work', value: 'WORK' },
    { label: 'Other', value: '' },
  ];
  constructor(
    private googlePlacesService: GooglePlacesService,
    private modalController: ModalController,
    private customerService: CustomerService,
    private businessService: BusinessService
  ) {}

  ngOnInit() {
    this.getBusinessDetail();
    this.addresses.forEach((address) => {
      const uppercaseTag = address.tag.toUpperCase();
      this.tagSet.add(uppercaseTag);
    });
    this.setDefaultSelectedTag();
    this.addressForm = new FormGroup({
      houseFlatBlock: new FormControl(
        this.addressToEdit ? this.addressToEdit.line1 : '',
        [
          Validators.required,
          Validators.pattern("^(?=.*[a-zA-Z0-9])[a-zA-Z0-9, .'/-]+$"),
        ]
      ),
      apartmentRoadArea: new FormControl(
        this.addressToEdit ? this.addressToEdit.line2 : '',
        [
          Validators.required,
          // Validators.pattern("^(?=.*[a-zA-Z0-9])[a-zA-Z0-9, .'/-]+$"),
        ]
      ),
      city: new FormControl(
        this.addressToEdit
          ? this.addressToEdit.city
          : this.business
          ? this.business.address.city
          : '',
        [Validators.required, Validators.pattern('[a-zA-Z_ ]*')]
      ),
      state: new FormControl(
        this.addressToEdit
          ? this.addressToEdit.state
          : this.business
          ? this.business.address.state
          : '',
        [Validators.required, Validators.pattern('[a-zA-Z_ ]*')]
      ),
      country: new FormControl(
        this.addressToEdit
          ? this.addressToEdit.country
          : this.business
          ? this.business.address.country
          : '',
        [Validators.required, Validators.pattern('[a-zA-Z_ ]*')]
      ),
      pin: new FormControl(this.addressToEdit ? this.addressToEdit.zip : '', [
        Validators.required,
        Validators.pattern('^[0-9]{5,6}$'),
      ]),
      saveAddress: new FormControl('', []),
      addressTag: new FormControl(
        this.addressToEdit ? this.addressToEdit.tag : '',
        [
          Validators.required,
          Validators.pattern("^(?=.*[a-zA-Z0-9])[a-zA-Z0-9, .'/-]+$"),
        ]
      ),
    });
    if (this.addressToEdit) {
      this.destinationAddress = this.addressToEdit.line2; // Initialize destinationAddress if updating an address 
    }
  }

  getBusinessDetail() {
    this.businessSubscription = this.businessService
      .getBusinessSubscription()
      .subscribe((business) => {
        if (business) {
          this.business = business;
          console.log(business);
          this.businessCoordinates = this.business.address.coordinates;
        }
      });
  }

  onAddressInput() {
    if (this.destinationAddress?.length > 0) {
      let mapInput: GMapsSuggestionInput = {
        destination: this.destinationAddress,
        latLong: this.businessCoordinates
          ? `${this.businessCoordinates.latitude},${this.businessCoordinates.longitude}`
          : '',
      };

      this.googlePlacesService.getAutocompleteResults(mapInput).subscribe(
        (result: any) => {
          if (result) {
            this.autocompleteResults =
              result.data.GoogleMapAddressSuggestions.predictions;
          } else {
            console.error('Error fetching autocomplete results');
          }
        },
        (error) => {
          console.error('Error:', error);
        }
      );
    } else {
      this.autocompleteResults = [];
    }
  }

  onAddressSelect(place: any) {
    console.log('Selected Place:', place);
    this.destinationAddress = place.description; // Set the input field to the selected place's description
    this.autocompleteResults = []; // Clear autocomplete results
  }

  handlerForm() {
    let address: CustomerAddress;
    let customerDetails: CustomerInput;
  
    if (this.addressToEdit) {
      // Update the existing address
      address = {
        id: this.addressToEdit.id, // Keep the existing ID
        line1: this.addressForm.get('houseFlatBlock').value,
        line2: this.addressForm.get('apartmentRoadArea').value,
        country: this.addressForm.get('country').value,
        state: this.addressForm.get('state').value,
        city: this.addressForm.get('city').value,
        zip: this.addressForm.get('pin').value,
        tag: this.addressForm.get('addressTag').value,
      };

      const addressToUpdate = this.customerDetails.address.map((addr) => {
        return addr.id === this.addressToEdit.id ? address : addr;
      });
  
      customerDetails = {
        ...this.customerDetails,
        address: addressToUpdate,
      };
  
    } else {
      // Create a new address
      address = {
        id: 'id_' + Math.random().toString(16).slice(2), // Ensure a unique ID
        line1: this.addressForm.get('houseFlatBlock').value,
        line2: this.addressForm.get('apartmentRoadArea').value,
        country: this.addressForm.get('country').value,
        state: this.addressForm.get('state').value,
        city: this.addressForm.get('city').value,
        zip: this.addressForm.get('pin').value,
        tag: this.addressForm.get('addressTag').value,
      };
      customerDetails = {
        address: [...this.customerDetails.address, address],
        description: this.customerDetails.description,
        emailId: this.customerDetails.emailId,
        id: this.customerDetails.id,
        name: this.customerDetails.name,
        phoneNumber: this.customerDetails.phoneNumber,
        paymentCustomerId: this.customerDetails.paymentCustomerId,
        handle: this.customerDetails.handle,
        profileImageUrl: this.customerDetails.profileImageUrl,
        modifiedAt: this.customerDetails.modifiedAt
      };
    }
    

    this.customerService
      .updateCustomer(this.customerDetails.id, customerDetails)
      .subscribe((data: any) => {
        if (data) {
          let updatedWithAddress: CustomerInput = data.data.UpdateCustomer;
          this.modalController.dismiss({
            updatedAddressList: [...updatedWithAddress.address],
            address: address,
          });
        }
      });
  }

  close() {
    this.modalController.dismiss();
  }

  selectTag(tag: any): void {
    this.selectedTag = tag.label;
    this.addressForm.get('addressTag').setValue(tag.value);
  }

  setDefaultSelectedTag() {
    this.selectedTag = 'Home';
    if (this.tagSet.has('HOME') && this.tagSet.has('WORK')) {
      this.selectedTag = 'Other';
    } else if (this.tagSet.has('HOME')) {
      this.selectedTag = 'Work';
    }
  }
}
